import helpers from '../helpers';

let initState = false;
let resizeTimeout = null;

function destroy() {
	helpers.$document.off('.cursor');
	helpers.$body.find('.cursor').remove();

	initState = false;
}

function init() {
	if (helpers.isMobile()) {
		return;
	}

	helpers.$body.append('<div class="cursor"></div>');

	const $cursor = $('.cursor');

	helpers.$html.addClass('state-custom-cursor');

	helpers.$document.on('mouseenter', 'a, .accordion__item__header, .buy__opt label', () => {
		helpers.$html.addClass('state-custom-cursor-active');
	});

	helpers.$document.on('mouseleave', 'a, .accordion__item__header, .buy__opt label', () => {
		helpers.$html.removeClass('state-custom-cursor-active');
	});

	helpers.$document
		.on('mousemove.cursor', (e) => {
			$cursor.removeClass('is-invisible');

			gsap.to($cursor, {
				duration: 0.15,
				x: e.clientX,
				y: e.clientY,
				z: 0.001,
			});
		});

	helpers.$window
		.off('.cursor')
		.on('resize.cursor', () => {
			if (resizeTimeout) {
				clearTimeout(resizeTimeout);
			}

			resizeTimeout = setTimeout(() => {
				if (!helpers.isMobile() && !initState) {
					init();
				} else if (helpers.isMobile() && initState) {
					destroy();
				}
			}, 500);
		});

	initState = true;
}

export default {
	init,
};
